import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/error.tsx");
